import { FC, PropsWithChildren } from 'react';

import { useGetProfileSettings } from 'app/api/hooks/core/v1/payor/reports';

// Component Definition
const PayorDataLoader: FC<PropsWithChildren> = props => {
  const profileSettings = useGetProfileSettings();

  if (profileSettings) {
    return props.children;
  }

  return null;
};

export default PayorDataLoader;
